import { Box } from "@mui/material";
import React, { useState } from "react";
import LogoutConfirmation from "./LogoutConfirmation";

const Logout = () => {
  const [openConfirmation, setOpenConfirmation] = useState<boolean>(false);
  const handleLogout = () => {
    localStorage.removeItem("frcsit:access-token");
    window.location.href = "/";
  };
  return (
    <>
      <Box px={2} py={1}>
        <button
          onClick={() => {
            setOpenConfirmation(true);
          }}
          className="thm-btn become-volunteer__btn"
        >
          Logout
        </button>
      </Box>
      <LogoutConfirmation
        open={openConfirmation}
        setOpen={setOpenConfirmation}
        onLogout={handleLogout}
      />
    </>
  );
};

export default Logout;
